import { Divider, styled, Typography } from "@mui/material";

export const ResultHeadlineTypography = styled(Typography)({
    color: "var(--community-color-secondary-text)",
    fontSize: "16px",
    fontWeight: 700,
});

export const ListLocationItemsContainer = styled("div")({
    "& .MuiListItemButton-root": {
        padding: "8px 16px",
    },
    "& .MuiDivider-root": {
        margin: "0px 16px 0px 80px",
    },
    overflowY: "auto",
});

export const DividerMargined = styled(Divider)({
    margin: "8px 16px 8px 80px",
});
